import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPatch } from '../lib/api';
import { useAuth } from './useAuth';

export interface Profile {
  lastName: string;
  firstName: string;
  patronymic: string | null;
  phone: string;
  birthDate: string | null;
}

export const PROFILE_QUERY_KEY = ['profile'] as const;

export function useProfile() {
  const { data: user } = useAuth();
  return useQuery({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: async () => (await apiGet<{ profile: Profile | null }>('/api/profile')).profile,
    enabled: !!user,
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: Profile) =>
      apiPatch<{ profile: Profile }>('/api/profile', input).then((res) => res.profile),
    onSuccess: (profile) => queryClient.setQueryData(PROFILE_QUERY_KEY, profile),
  });
}
